import React from 'react';

import Icon from 'components/DesignSystem/Icon';
import Tag from 'components/DesignSystem/Tag';
import { cssVar } from 'constants/theme';

import './index.scss';

export interface StatusDetail {
  label: string;
  value: React.ReactNode;
}

export interface StatusListItem {
  key: string | number;
  primary: React.ReactNode;
  secondary?: React.ReactNode;
  badge?: { text: string; color?: string };
  details: StatusDetail[];
  searchText?: string;
}

export default function StatusAccordionItem({
  item,
  isOpen,
  onToggle,
}: {
  item: StatusListItem;
  isOpen: boolean;
  onToggle: () => void;
}) {
  return (
    <div className={`status-accordion-item${isOpen ? ' open' : ''}`}>
      <button
        type="button"
        className="status-accordion-header"
        aria-expanded={isOpen}
        onClick={onToggle}
      >
        <span className="status-accordion-texts">
          <span className="status-accordion-primary">{item.primary}</span>
          {item.secondary && (
            <span className="status-accordion-secondary">{item.secondary}</span>
          )}
        </span>
        <span className="status-accordion-right">
          {item.badge && (
            <Tag backgroundColor={item.badge.color} className="status-accordion-badge">
              {item.badge.text}
            </Tag>
          )}
          <Icon
            iconType={isOpen ? 'down_arrow' : 'right_arrow'}
            color={cssVar(isOpen ? 'text-accent' : 'text-muted')}
            className="status-accordion-chevron"
          />
        </span>
      </button>
      {isOpen && (
        <div className="status-accordion-details">
          {item.details.map((detail) => (
            <div key={detail.label} className="status-accordion-detail">
              <span className="status-accordion-detail-label">{detail.label}</span>
              <span className="status-accordion-detail-value">{detail.value}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
